export default {
  ...process.env,
  dev: "development",
  lab: "lab",
  staging: "staging",
  prod: "production"
};
